import { AccountNotifications } from '~/components/AccountNotifications';
import {
  AccountConnectorServiceEnum,
  useEnrichmentAccountNotificationsQuery,
} from '~/generated/graphql';

import { Integration } from '../../Show/FieldMappingForm/types';

type EnrichmentAccountNotificationProps = {
  integration: Integration;
};
export function EnrichmentAccountNotifications({
  integration,
}: EnrichmentAccountNotificationProps) {
  const { data } = useEnrichmentAccountNotificationsQuery({
    variables: {
      // TODO: We eventually need a tighter type we pass around
      // for service/integration which we sort of use interchangeably.
      service: integration as AccountConnectorServiceEnum,
    },
  });

  if (!data) {
    return null;
  }

  return (
    <AccountNotifications
      isFromEnrichmentPage
      notifications={data?.accountNotifications}
    />
  );
}
